import { useCurrentUserContext } from '@/contexts';
import { Role } from '@/types/gql.generated';
import type { Collaborator } from '../types';
import { useCollaborators } from './useCollaborators';

type Ret = {
  owner: Collaborator | null;
  isOwnerMe: boolean;
  isLoading: boolean;
};

export const useOwner = (): Ret => {
  const { currentUser } = useCurrentUserContext();
  const { collaborators = [], isLoading } = useCollaborators();
  const owner = collaborators.find((item) => item.role === Role.Owner) ?? null;

  return {
    isLoading,
    owner,
    isOwnerMe: Boolean(owner && owner?.id === currentUser?.id),
  };
};
